var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 6c-24.27 0-44 19.719-44 44 0 24.273 19.727 44 44 44 24.281 0 44-19.73 44-44 0-24.281-19.719-44-44-44zm0 4c22.121 0 40 17.879 40 40 0 22.109-17.883 40-40 40-22.109 0-40-17.891-40-40 0-22.117 17.891-40 40-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.766 32.988c-0.77734 0.078125-1.4414 0.59766-1.6992 1.3398-0.25391 0.73828-0.054687 1.5586 0.51172 2.0977l13.562 13.594-13.562 13.562c-0.78516 0.78516-0.78516 2.0586 0 2.8438 0.78516 0.78516 2.0586 0.78516 2.8438 0l13.594-13.594 13.562 13.594c0.78516 0.78516 2.0586 0.78516 2.8438 0 0.78516-0.78516 0.78516-2.0586 0-2.8438l-13.594-13.562 13.594-13.594c0.59766-0.57422 0.77344-1.4609 0.44922-2.2227-0.32422-0.76562-1.0898-1.2461-1.918-1.2148-0.51953 0.011719-1.0117 0.22656-1.375 0.59375l-13.562 13.562-13.594-13.562c-0.37891-0.38281-0.89844-0.59766-1.4375-0.59375-0.074219-0.003906-0.14844-0.003906-0.21875 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpClose);
export default __webpack_public_path__ + "static/media/np_close.d571cdf7502c6b6558481f2267ed664f.svg";
export { ForwardRef as ReactComponent };